<mat-button-toggle
  (click)="switchViewModes()"
  class="toolbar-button mat-button-toggle-checked"
  [matTooltip]="tooltip$ | async"
>
  <mat-icon [h3CustomIcon]="viewModeIcon$ | async"></mat-icon>
  <mat-icon svgIcon="toggleIcon" class="toggle-icon"></mat-icon>
</mat-button-toggle>
